<template>
  <b-row align-h="center" align-v="center" align-content="center">
    <b-col
      align-h="center"
      align-self="center"
      align-v="center"
      align-content="center"
    >
      <DxVectorMap
        id="vector-map"
        ref="vectorMap"
        :bounds="bounds"
        :zoomFactor="zoomFactor"
        :center="[19, 55]"
        :on-click="drillDown"
        :max-zoom-factor="15"
        @zoom-factor-changed="zoomFactorChanged"
      >
        <DxSize :height="mapHeight" :width="mapWidth" />
        <DxLayer
          ref="countryColorLayer"
          :data-source="mapsWorld"
          :customize="customizeLayer"
        />

        <DxLayer
          :data-source="readyMarkerData"
          data-field="url"
          element-attr="countryId"
          :size="100"
          element-type="image"
          type="marker"
          :customize="manipulateMarkers"
          style="pointer-events: none"
        ></DxLayer>
      </DxVectorMap>
      <div style="display: none">
        <div v-for="(feature, index) in readyMarkerData.features" :key="index">
          <MapMarker
            :id="'test_' + index"
            style="height: 'auto'; width: '200px'"
            :Text="feature.properties.text"
            :CountryCode="feature.properties.countryId"
            :Color="getColor(feature.properties.value)"
            :Url="feature.properties.url"
            :Svg="feature.properties.svg"
          />
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import * as mapsData from "devextreme/dist/js/vectormap-data/europe.js";
import * as mapsDataWorld from "devextreme/dist/js/vectormap-data/world.js";

import MapMarker from "./MapMarker";

import {
  DxVectorMap,
  DxLayer,
  DxSource,
  DxTooltip,
  DxBorder,
  DxFont,
  DxSize,
  DxLabel
} from "devextreme-vue/vector-map";

// Set fix coordinates for marker
const fixMarkerData = {
  FR: { coordinates: [0.1090881, 44.895961] },
  US: { coordinates: [-100, 37] },
};

export default {
  name: "Global",

  components: {
    DxVectorMap,
    DxLayer,
    DxSource,
    DxTooltip,
    DxBorder,
    DxFont,
    DxSize,
    DxLabel,
    MapMarker
  },
  props: {
    colorRange: Array,
    countryValues: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      zoomFactor: 4,
      updatedMap: false,

      markerSize: 40,
      publicPath: process.env.BASE_URL,
      worldData: mapsData.europe,
      colorGroups: [0, 70, 90, 100],
      bounds: [-180, 85, 180, -60],
      mapsWorld: mapsDataWorld.world,
      fixMarkerData: fixMarkerData,
      testResult: {
        type: "FeatureCollection",
        features: []
      }
    };
  },
  watch: {},
  computed: {
    mapHeight: function() {
      return window.innerHeight * 0.65;
    },
    mapWidth: function() {
      return window.innerWidth * 0.96;
    },
    readyMarkerData: function() {
      let result = {
        type: "FeatureCollection",
        features: []
      };
      var start = new Date().getTime();
      if (this.countryValues?.AggregatedData && this.mapsWorld?.features) {
        this.countryValues.AggregatedData.forEach(country => {
          this.mapsWorld.features.forEach(feature => {
            if (
              country.CountryId &&
              country.CountryId == feature.properties?.iso_a2
            ) {
              let flatCoordinates = this.flatArray(
                feature.geometry.coordinates
              );
              result.features.push({
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates:
                    this.fixMarkerData[country.CountryId]?.coordinates ||
                    this.avgCoordinates(flatCoordinates)
                },
                properties: {
                  // This only works because all flags are < 4KB and therefore embedded by webpack and served as data url in base64.
                  // This is needed because later the resulting SVG is copied to the marker elements as self contained svg
                  // https://cli.vuejs.org/guide/html-and-static-assets.html#relative-path-imports
                  url: require(`@/assets/flags/${country.CountryId}.png`),
                  value: country.CXScore || -1,
                  text: country.CXScore ? (country.CXScore.toFixed(0) + "% ") : "N/A",
                  countryId: country.CountryId
                }
              });
            }
          });
        });
        this.updatedMap = false;
      }
      var end = new Date().getTime();
      var time = end - start;
      return result;
    }
  },
  mounted: function() {
    this.changeMarkerSize();
    this.markerSize = this.getZoomFactor() * 10;
  },
  updated() {
    this.changeMarkerSize();
    if (!this.updatedMap) {
      this.mapsWorld = {};
      this.$nextTick(function() {
        this.mapsWorld = mapsDataWorld.world;
      });
    }
  },
  methods: {
    svgToBase64(svg) {
      let s = new XMLSerializer().serializeToString(svg);

      return "data:image/svg+xml;base64," + window.btoa(s);
    },
    zoomFactorChanged({ zoomFactor }) {
      if (zoomFactor > 15) {
        this.zoomFactor = 15;
        const vectorMap = this.$refs["vectorMap"].instance;
        vectorMap.zoomFactor(this.zoomFactor);
      } else if (zoomFactor < 3.5) {
        this.zoomFactor = 3.5;
        const vectorMap = this.$refs["vectorMap"].instance;
        vectorMap.zoomFactor(this.zoomFactor);
      }
    },
    getZoomFactor() {
      const vectorMap = this.$refs["vectorMap"].instance;
      return vectorMap.zoomFactor();
    },
    getColor(value) {
      if (!this.colorRange) return null;

      if (this.colorRange.find(thres => thres.Minimum <= value && thres.Maximum >= value)) {
        return this.colorRange.find(
          thres => thres.Minimum <= value && thres.Maximum >= value
        )?.Color;
      } else {
        return "#d2d2d2";
      };
    },
    changeMarkerSize() {
      let markerImages = this.$el.querySelectorAll(".dxm-marker image");
      markerImages?.forEach(markerImage => {
        markerImage.setAttribute("style", "pointer-events: none;");
        markerImage.setAttribute("width", "100");
        markerImage.setAttribute("height", "40");
      });
    },
    drillDown(e) {
      // Only if left mouse button was clicked
      if (e?.event?.button !== 0 || !e.target) return;

      // this.getZoomFactor();
      // this.makeMarker();
      if (e.target.attribute("iso_a2")) {
        this.$emit("drilldownToRetailer", e.target.attribute("iso_a2"));
      }
    },
    manipulateMarkers(elements) {
      elements?.forEach((element, index) => {
        this.countryValues.AggregatedData?.forEach(data => {
          if (element.attribute("countryId").indexOf(data.CountryId) > -1) {
            let s = new XMLSerializer().serializeToString(
              document.getElementById("test_" + index)
            );
            element.attribute(
              "url",
              "data:image/svg+xml;base64," + window.btoa(s)
            );
            element.attribute("test", window.btoa(s));
          }
        });
      });
    },
    flatArray(array) {
      return array[0].map(element => {
        if (Array.isArray(element) && element.length === 2) {
          return element;
        } else {
          return element.flat(1);
        }
      });
      // return array.map(element => {
      //   if (Array.isArray(element) && element.length === 2) {
      //     return element;
      //   } else if (Array.isArray(element)) {
      //     return element.flat();
      //   }
      // });
    },
    avgCoordinates(coordinates) {
      let longitudeSum = 0;
      let latitudeSum = 0;
      coordinates?.forEach(coordinate => {
        longitudeSum += coordinate[0];
        latitudeSum += coordinate[1];
      });
      return [
        longitudeSum / coordinates.length,
        latitudeSum / coordinates.length
      ];
    },
    customizeLayer(elements) {
      elements?.forEach(element => {
        this.countryValues?.AggregatedData?.forEach(data => {
          if (data.CountryId == element.attribute("iso_a2")) {
            let color = this.getColor(data.CXScore || -1);
            element.applySettings({
              color: color + "BF",
              hoveredColor: color,
              selectedColor: color
            });
          }
        });
      });
      this.updatedMap = true;
    }
  }
};
</script>

<style scoped>
#vector-map {
  height: 100%;
}
</style>
<style>
/* #vector-map .dxm-marker {
  background-color: red;
  background: black;
  content: "TEST CONTENT";
} */
</style>
